import { useContext } from 'react';
import LayoutTypeContext from '../contexts/LayoutTypeContext';

const useLayoutTypeContext = () => useContext(LayoutTypeContext);

export default useLayoutTypeContext;
